<template>
    <div class="personages-add">
        <slot v-if="!showForm" name="trigger">
            <button
                type="button"
                class="button personages-add-trigger"
                @click.stop="showForm = true"
            >
                <IconPlus class="personages-add-trigger__icon" />
                <span v-t="'personages.manager.add'" class="personages-add-trigger__text" />
            </button>
        </slot>
        <table v-if="showForm" class="control-table control-table--compact personages-add__table">
            <tbody>
                <PersonagesCard
                    ref="personageRes"
                    :model-value="initialItem"
                    class="control-table__row personages-add__card"
                    @update:model-value="onUpdate"
                />
            </tbody>
        </table>
    </div>
</template>

<script>
import { IconPlus } from '@speechki-frontend/shared/ui/icons';
import PersonagesCard from './PersonagesCard';
import { mapState } from 'vuex';

export default {
    name: 'PersonagesAdd',
    components: {
        IconPlus,
        PersonagesCard
    },
    props: {
        skipTrigger: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showForm: false,
            initialItem: {}
        };
    },
    computed: {
        ...mapState({
            book: ({ book }) => book.book
        })
    },
    async created() {
        let { speaker } = this.book;

        if (this.skipTrigger) {
            this.showForm = true;
        } else {
            speaker = {};
        }

        this.initialItem = { speaker };
    },
    methods: {
        onUpdate(event) {
            this.showForm = false;
            this.$emit('personageAdded', event);
        },
        save() {
            const { personageRes } = this.$refs;
            if (!personageRes) return false;
            return personageRes.save();
        }
    }
};
</script>

<style lang="scss" src="./PersonagesAdd.scss"></style>
